module.exports = __webpack_public_path__ + "static/fonts/1a6dec8e-26f9-4243-8495-835709538f92.3939ac6.eot";